import React, { useState } from "react";
import { Link, animateScroll as scroll } from "react-scroll";
import { COUPLE_NAME } from "../config";

const NAV_LINKS = [
  { id: "welcome", label: "Welcome" },
  { id: "infos", label: "Venue" },
  { id: "itinerary", label: "Timeline" },
  { id: "faq", label: "FAQ" },
  { id: "rsvp", label: "RSVP" },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow z-50">
      <div className="max-w-6xl mx-auto flex justify-between items-center px-6 py-4">
        <div
          onClick={() => scroll.scrollToTop()}
          className="flex items-center cursor-pointer"
        >
          <img
            src="/Images/Logo_AT.png"
            alt="Logo"
            className="h-8 w-auto mr-2"
          />
          <h1 className="text-2xl font-bold text-[#90CAFF] [-webkit-text-stroke:0.25px_#000000]">
            {COUPLE_NAME}
          </h1>
        </div>

        <div className="hidden md:flex space-x-6">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.id}
              to={link.id}
              smooth
              duration={600}
              className="cursor-pointer hover:text-amber-700 font-display font-bold"
            >
              {link.label}
            </Link>
          ))}
        </div>

        <button className="md:hidden focus:outline-none" onClick={() => setIsOpen((prev) => !prev)}>
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>

      {isOpen && (
        <div className="md:hidden bg-white shadow-md px-6 py-4 space-y-4">
          {NAV_LINKS.map((link) => (
            <Link
              key={link.id}
              to={link.id}
              smooth
              duration={600}
              className="block cursor-pointer hover:text-amber-700 font-display font-bold"
              onClick={() => setIsOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}
